var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAcceptApproval(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6699_42027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.8102 87.2898L82.4102 74.1998L52.4502 66.9998L5.49023 94.1598L70.4902 176L134.02 139.16L121.34 123.2",
    stroke: "#001419",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7103 83.82L49.3003 68.79L52.4403 66.98L65.7103 83.82Z",
    fill: "#6D45E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7103 83.82L49.3003 68.79L52.4403 66.98L65.7103 83.82Z",
    stroke: "#001419",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5001 126.01C86.7501 121.55 82.2301 113.99 82.3201 106.96C76.8301 105.73 71.0801 106.55 66.1401 109.27C56.1201 115.07 54.4401 127.91 62.4001 137.91C70.3601 147.93 84.9301 151.33 94.9501 145.51C100.76 142.26 104.16 135.94 103.67 129.3C100.44 128.78 97.3301 127.67 94.5001 126.02V126.01Z",
    fill: "#00C707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5001 126.01C86.7501 121.55 82.2301 113.99 82.3201 106.96C76.8301 105.73 71.0801 106.55 66.1401 109.27C56.1201 115.07 54.4401 127.91 62.4001 137.91C70.3601 147.93 84.9301 151.33 94.9501 145.51C100.76 142.26 104.16 135.94 103.67 129.3C100.44 128.78 97.3301 127.67 94.5001 126.02V126.01Z",
    stroke: "#001419",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3804 74.16L65.7104 83.82L52.4404 66.98",
    stroke: "#001419",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2305 100.51L53.1505 84.3499",
    stroke: "#001419",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9404 111.51L77.3704 86.3699",
    stroke: "#001419",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0903 134.47L86.5203 137.25L85.8403 120.59",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5601 92.3601L84.2701 99.7301C79.3901 108.16 83.9701 119.93 94.4901 126C103.92 131.46 116.49 131.12 122.41 121.65L126.62 114.34",
    stroke: "#001419",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8603 85.51C92.3003 87.04 89.4803 89.92 88.0303 93.51C84.4103 102.4 90.2003 112.79 99.1603 117.96C107.14 122.57 117.55 123.01 124.03 117.32C125.02 116.45 125.89 115.46 126.63 114.37",
    stroke: "#001419",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.04 56.0502L148.35 64.1402C146.61 67.1602 142.93 68.7502 138.81 68.7502C126.75 68.7502 116.88 56.3302 121.37 48.5602L126.04 40.4702C123.92 44.1602 125.15 48.6902 127.5 52.1102C134.32 62.0702 148.85 63.2702 153.05 56.0402L153.04 56.0502Z",
    stroke: "#001419",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.86 87.9602C164.02 100.03 152.49 113.73 143.12 121.23C139.83 120.73 136.62 119.82 133.56 118.51C127.62 115.53 122.31 111.43 117.93 106.43L124.66 94.8602C123.58 92.8902 122.59 90.8802 121.71 88.8102C120.8 89.2602 119.77 89.4102 118.76 89.2402C120.31 94.2702 118.14 96.3802 114.77 95.9502C116.23 100.62 112.9 102.55 108.34 100.81C108.98 104.49 103.7 105.05 99.4599 101.49C96.0899 98.6602 90.7199 90.6702 94.3599 87.0902C94.8199 86.6502 95.4099 86.3602 96.0399 86.2802C95.3599 83.6902 95.5399 81.0702 98.0599 79.5502C98.4699 79.2902 98.9399 79.1302 99.4199 79.0602C98.6999 75.0102 100.83 72.2102 103.96 71.2902C104.02 69.2002 105.18 67.3002 107 66.2802C105.41 63.8302 104.17 61.1602 103.31 58.3602C102.34 54.3702 105.41 52.0002 109.49 55.1502C110.83 56.1902 112.61 57.6802 114.73 59.4002C115.32 59.0602 120.85 56.3402 120.85 56.3402C121.07 57.0202 121.34 57.6702 121.66 58.3102C121.66 58.3102 120.66 60.0502 119.05 62.7902C124.21 66.6502 130.58 70.7702 137.37 73.0002L139.81 68.8002C142.68 68.7302 145.41 67.5402 147.43 65.4902C153.79 71.0602 150.72 68.0902 169.86 87.9702V87.9602Z",
    stroke: "#001419",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.43 59.3601C140.15 64.0801 125.55 55.5901 124.97 45.2801C124.64 39.4201 129.37 35.8701 135.57 35.8701C142.89 35.8701 150.62 40.8601 153.24 47.5701C155.11 52.3501 154.01 57.0301 149.42 59.3601H149.43Z",
    fill: "#6D45E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.43 59.3601C140.15 64.0801 125.55 55.5901 124.97 45.2801C124.64 39.4201 129.37 35.8701 135.57 35.8701C142.89 35.8701 150.62 40.8601 153.24 47.5701C155.11 52.3501 154.01 57.0301 149.42 59.3601H149.43Z",
    stroke: "#001419",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.57 118.5C132.21 121.92 131.98 124.4 133.14 125.36C134.69 126.65 138.43 124.94 143.14 121.22C139.87 120.65 136.66 119.73 133.57 118.5Z",
    fill: "#6D45E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.57 118.5C132.21 121.92 131.98 124.4 133.14 125.36C134.69 126.65 138.43 124.94 143.14 121.22C139.87 120.65 136.66 119.73 133.57 118.5Z",
    stroke: "#001419",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.72 81.5702L169.86 87.9602C174.04 78.8302 170.98 76.6902 163.72 81.5702Z",
    fill: "#6D45E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.72 81.5702L169.86 87.9602C174.04 78.8302 170.98 76.6902 163.72 81.5702Z",
    stroke: "#001419",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.61 114.35C126.21 114.97 125.76 115.56 125.27 116.11L117.92 106.43C120.51 109.39 123.43 112.04 126.61 114.35Z",
    fill: "#6D45E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.61 114.35C126.21 114.97 125.76 115.56 125.27 116.11L117.92 106.43C120.51 109.39 123.43 112.04 126.61 114.35Z",
    stroke: "#001419",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.2 100.79C183.23 102.19 182.12 103.35 180.72 103.37C179.32 103.39 178.16 102.29 178.14 100.89C178.14 100.86 178.14 100.82 178.14 100.79C178.17 99.3902 179.33 98.2802 180.72 98.3102C182.08 98.3402 183.18 99.4302 183.2 100.79Z",
    fill: "#6D45E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.2 100.79C183.23 102.19 182.12 103.35 180.72 103.37C179.32 103.39 178.16 102.29 178.14 100.89C178.14 100.86 178.14 100.82 178.14 100.79C178.17 99.3902 179.33 98.2802 180.72 98.3102C182.08 98.3402 183.18 99.4302 183.2 100.79Z",
    stroke: "#001419",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.82 68.74C132.27 68.97 125.24 64.91 121.67 58.25C121.67 58.25 120.67 59.99 119.06 62.73C124.22 66.58 130.59 70.71 137.38 72.94L139.82 68.74Z",
    fill: "#00C707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.82 68.74C132.27 68.97 125.24 64.91 121.67 58.25C121.67 58.25 120.67 59.99 119.06 62.73C124.22 66.58 130.59 70.71 137.38 72.94L139.82 68.74Z",
    stroke: "#001419",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.63 94.8601C123.55 92.8901 122.56 90.8801 121.68 88.8101C120.77 89.2601 119.74 89.4101 118.73 89.2401C120.28 94.2701 118.11 96.3801 114.74 95.9501C116.2 100.62 112.87 102.55 108.31 100.81C108.95 104.49 103.67 105.05 99.43 101.49C99.23 101.32 99 101.09 98.73 100.85C99.83 103.9 102.02 106.44 104.87 107.97C108.65 110.14 115.03 111.18 117.08 107.76L124.62 94.8501L124.63 94.8601Z",
    fill: "#00C707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.63 94.8601C123.55 92.8901 122.56 90.8801 121.68 88.8101C120.77 89.2601 119.74 89.4101 118.73 89.2401C120.28 94.2701 118.11 96.3801 114.74 95.9501C116.2 100.62 112.87 102.55 108.31 100.81C108.95 104.49 103.67 105.05 99.43 101.49C99.23 101.32 99 101.09 98.73 100.85C99.83 103.9 102.02 106.44 104.87 107.97C108.65 110.14 115.03 111.18 117.08 107.76L124.62 94.8501L124.63 94.8601Z",
    stroke: "#001419",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.63 94.8601C126.95 99.0201 129.98 103.04 133.46 104.52",
    stroke: "#001419",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.07 62.73C114.62 59.4 112.52 57.42 109.51 55.11C105.44 51.99 102.37 54.33 103.33 58.32C104.97 65.12 115.18 78.19 119.66 83.46C119.66 83.46 120.38 85.73 121.7 88.81",
    stroke: "#001419",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.74 74.5002C142.23 74.2702 139.76 73.7402 137.37 72.9302",
    stroke: "#001419",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3804 78.7402C100.19 84.2202 105.73 90.3502 107.3 91.8602C109.31 93.9602 111.92 95.3802 114.77 95.9402",
    stroke: "#001419",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.69 88.81C119.52 89.92 115.85 89.24 111.63 85.35C109.68 83.55 103.77 76.65 103.96 71.25",
    stroke: "#001419",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0503 86.26C97.1303 90.3 100.43 94.64 101.78 96.09C103.59 98.14 105.83 99.75 108.34 100.82",
    stroke: "#001419",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.01 79.4202L194.5 99.7002",
    stroke: "#001419",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.15 125.38L155.25 144.7",
    stroke: "#001419",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.21 160.9C135.56 160.9 136.65 161.99 136.65 163.34C136.65 164.69 135.56 165.78 134.21 165.78C132.86 165.78 131.77 164.69 131.77 163.34C131.77 161.99 132.86 160.9 134.21 160.9Z",
    stroke: "#001419",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5703 24L80.5503 40.48",
    stroke: "#001419",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8101 32.26L72.3101 32.24",
    stroke: "#001419",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.08 51.1599L176.76 54.5399L180.48 55.0899L177.78 57.7199L178.42 61.4399L175.07 59.6799L171.74 61.4399L172.36 57.7199L169.66 55.0899L173.4 54.5399L175.06 51.1599H175.08Z",
    stroke: "#001419",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6699_42027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcceptApproval);
export default __webpack_public_path__ + "static/media/accept-approval.15508ac3dd9b0678ae17824f7b8d6c5f.svg";
export { ForwardRef as ReactComponent };